/**
 * @desc: 筛选器项 Error Boundary
 * 单个 renderer 渲染异常时显示 fallback，不影响其他筛选器
 */
import React from 'react';

import type { ReactNode, ErrorInfo } from 'react';

import './index.scss';

interface IFilterItemErrorBoundaryState {
  hasError: boolean;
}

interface IFilterItemErrorBoundaryProps extends IBaseProps {
  /** 筛选器字段名，用于日志标识 */
  field: string;
  children: ReactNode;
}

/**
 * React Error Boundary 必须使用 class 组件实现
 * （React 目前无 Hook 形式的 Error Boundary API）
 */
class FilterItemErrorBoundary extends React.Component<IFilterItemErrorBoundaryProps, IFilterItemErrorBoundaryState> {
  static getDerivedStateFromError(): Partial<IFilterItemErrorBoundaryState> {
    return { hasError: true };
  }

  constructor(props: IFilterItemErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.debug('[Filter] Renderer error for field:', this.props.field, error, errorInfo);
  }

  componentDidUpdate(prevProps: IFilterItemErrorBoundaryProps, prevState: IFilterItemErrorBoundaryState): void {
    if (!this.state.hasError || !prevState.hasError) {
      return;
    }

    if (prevProps.field !== this.props.field || prevProps.children !== this.props.children) {
      this.setState({ hasError: false });
    }
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return <div className="search-item dbi-common-filter-v3-error-boundary">{this.props.field}: render error</div>;
    }

    return this.props.children;
  }
}

export default FilterItemErrorBoundary;
